import shuffleLetters from 'shuffle-letters';

export default class ShuffleTextAnimation {
  constructor(elem, opts) {
    this.elm = elem
    this.flg = false
    this.threshold = opts.threshold || 0.8
    this.step = opts.step || 5
    this.fps = opts.fps || 55
    this.loadFireFlg = opts.loadFireFlg || ""
    this.init()
    this.eventBinds()
  }
  init() {
    this.w = window.innerWidth
    this.h = window.innerHeight
  }
  eventBinds() {
    window.addEventListener('load', () => {
      // this.inViewChecker()
      if(this.loadFireFlg === "true"){
        this.inViewChecker()
      }
    })
    window.addEventListener('scroll', () => {
      this.inViewChecker()
    })
  }
  inViewChecker() {
    const top = this.elm.getBoundingClientRect().top
    if (top < this.threshold * this.h && !this.flg) {
      this.flg = true
      this.elm.classList.add('is-active')
      this.shuffleAnim()
    }
  }
  shuffleAnim() {
    shuffleLetters(this.elm,{
      step: this.step,
      fps: this.fps
    });
  }
}